import styled from 'styled-components'
import { InsertStyleType } from 'src/types/type'

const MainWrap = styled.div<Pick<InsertStyleType, 'mainBg'>>`
  max-width: 492px;
  margin: 0 auto;
  background-color: ${props => props.mainBg};
`

export {
  MainWrap
}
